import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const ImageListContext = createContext(null);
const ImageListItemContext = createContext(null);
export const ImageListProvider = ({ list, children, }) => (_jsx(ImageListContext.Provider, { value: list, children: children }));
export const ImageListItemProvider = ({ entry, index, children, }) => (_jsx(ImageListItemContext.Provider, { value: { entry, index }, children: children }));
export const useImageList = () => {
    const list = useContext(ImageListContext);
    if (!list) {
        throw new Error('useImageList must be used within ImageListProvider');
    }
    return list;
};
export const useImageListItem = () => {
    const item = useContext(ImageListItemContext);
    if (!item) {
        throw new Error('useImageListItem must be used within an ImageGrid');
    }
    return item;
};
